module.exports = __webpack_public_path__ + "img/20.ae7f0490.jpg";